import Auth from './auth/reducer';
import App from './app/reducer';
import Notification from './notification/reducer'
import SidebarMenu from './sidebarMenu/reducer';

export default {
  Auth,
  App,
  Notification,
  SidebarMenu
};
